import React, {
    createContext,
    useContext,
    useState,
    useCallback,
} from 'react';
import { v4 as uuidv4 } from 'uuid';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);

    const removeToast = useCallback((id) => {
        setToasts((prev) =>
            prev.filter((toast) => toast.id !== id)
        );
    }, []);

    const addToast = useCallback(
        (message, options = {}) => {
            const id = uuidv4();
            const {
                type = 'info', // 'success', 'error', 'warning', 'info'
                duration = 4000, // auto-dismiss after 4 seconds
            } = options;

            const newToast = {
                id,
                message,
                type,
                duration,
            };
            setToasts((prev) => [...prev, newToast]);

            // Auto-dismiss logic
            setTimeout(() => removeToast(id), duration);
        },
        [removeToast]
    );

    return (
        <ToastContext.Provider
            value={{ addToast, removeToast, toasts }}
        >
            {children}
        </ToastContext.Provider>
    );
};

export const useToastContext = () =>
    useContext(ToastContext);
